import { useState } from "react";
import { Lightbulb } from "lucide-react";

// PATCH 40 Part 3 — inline, plain-English explanation shown by DEFAULT the moment an intervention fires.
// Wording is taken verbatim from the canonical glossary; "tell me why" (H3) reveals the academic citation.
export default function BiasNote({ bias, testid }) {
  const [why, setWhy] = useState(false);
  if (!bias) return null;
  return (
    <div data-testid={testid || `bias-${bias.key}`} className="k-muted"
      style={{ fontSize: 12, marginTop: 6, display: "flex", gap: 6, alignItems: "flex-start", lineHeight: 1.55 }}>
      <Lightbulb size={13} style={{ marginTop: 2, flex: "none" }} aria-hidden="true" />
      <span>
        <strong className="k-heading">{bias.plain_label}</strong> — {bias.plain}{" "}
        <button className="k-link" data-testid={`bias-why-${bias.key}`} style={{ fontSize: 12 }}
          onClick={() => setWhy((w) => !w)}>tell me why</button>
        {why && <span> Grounding: {bias.citation}.</span>}
      </span>
    </div>
  );
}
